'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _List = require('@material-ui/core/List');

var _List2 = _interopRequireDefault(_List);

var _ListItem = require('@material-ui/core/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ListItemText = require('@material-ui/core/ListItemText');

var _ListItemText2 = _interopRequireDefault(_ListItemText);

var _Menu = require('@material-ui/core/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _NativeSelect = require('@material-ui/core/NativeSelect');

var _NativeSelect2 = _interopRequireDefault(_NativeSelect);

var _ChevronDown = require('@eui/ds-icons/lib/ChevronDown');

var _ChevronDown2 = _interopRequireDefault(_ChevronDown);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITEM_HEIGHT = 44;
var DEFAULT_SELECTED_INDEX = 0;

var styles = function styles(theme) {
    return {
        // SelectionMenu
        root: {
            display: 'inline-flex'
        },
        icon: {
            fill: theme.palette.grey[500]
        },
        listPadding: {
            paddingTop: '0.125rem',
            paddingBottom: '0.125rem'
        },

        listItemRoot: {
            paddingTop: '0.125rem',
            paddingBottom: '0.125rem',
            paddingLeft: _tokens.spacingXSmall,
            paddingRight: _tokens.spacingXSmall,

            '&:hover $icon': {
                fill: theme.palette.ctaColor.hover,
                color: theme.palette.ctaColor.hover
            },

            '&$listItemDisabled': {
                opacity: '1',
                '&:hover $icon': {
                    fill: theme.palette.grey[400]
                }
            }
        },
        listItemDisabled: {},

        listItemButton: {
            borderRadius: _tokens.borderRadiusMedium,
            border: _tokens.borderWidthThin + ' solid transparent',
            height: _tokens.sizingLarge,
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '&:focus': {
                backgroundColor: 'transparent',
                borderColor: theme.palette.grey[300],
                boxShadow: _tokens.boxShadowFocus
            }
        },

        disabled: {
            color: theme.palette.grey[500],
            fill: theme.palette.grey[400]
        },
        listItemTextRoot: {
            paddingRight: _tokens.spacingXSmall
        },
        menuRoot: {
            border: _tokens.borderWidthThin + ' solid ' + theme.palette.grey[400],
            boxShadow: '0 0.125rem 0.0625rem -0.0625rem rgba(0, 0, 0, 0.12), 0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.21)'
        },

        // Native styles
        nativeSelectRoot: {
            marginRight: _tokens.spacingXxSmall,
            height: _tokens.sizingLarge,
            '&:hover $nativeIcon': {
                fill: theme.palette.ctaColor.hover
            },
            '&:hover $nativeIconDisabled': {
                fill: theme.palette.grey[400]
            }
        },
        nativeSelect: {
            height: 'auto',
            borderRadius: _tokens.borderRadiusMedium,
            border: _tokens.borderWidthThin + ' solid transparent',
            width: 'calc(100% - ' + _tokens.spacingMedium + ')',
            paddingLeft: _tokens.spacingXSmall,
            paddingRight: _tokens.spacingMedium,
            '&:focus': {
                backgroundColor: 'transparent',
                borderColor: theme.palette.grey[300],
                boxShadow: _tokens.boxShadowFocus,
                borderRadius: _tokens.borderRadiusMedium
            },
            '&:disabled': {
                color: theme.palette.grey[400]
            }
        },
        nativeIcon: {
            top: 'calc(50% - .5rem)',
            fill: theme.palette.grey[500]
        },
        nativeIconDisabled: {
            fill: theme.palette.grey[400]
        }
    };
};

/**
 * Use this smaller dropdown when space is limited and the dropdown does not need to be prominent.
 * @done true
 * @updated true
 * @versionAdded v2.6.0
 * @examples
 *  SelectionMenuExample
 *  SelectionMenuDisabled
 *  CardSelectionMenu
 *  CustomizedSelectionMenu
 *  SelectionMenuNative
 */

var SelectionMenu = function (_React$Component) {
    _inherits(SelectionMenu, _React$Component);

    function SelectionMenu(props) {
        _classCallCheck(this, SelectionMenu);

        var _this = _possibleConstructorReturn(this, (SelectionMenu.__proto__ || Object.getPrototypeOf(SelectionMenu)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            anchorEl: null,
            selectedIndex: _this.props.selectedIndex || DEFAULT_SELECTED_INDEX
        };
        return _this;
    }

    _createClass(SelectionMenu, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                idProp = _props.id,
                classes = _props.classes,
                disabled = _props.disabled,
                childrenProp = _props.children,
                ContainerProps = _props.ContainerProps,
                ListProps = _props.ListProps,
                ListItemProps = _props.ListItemProps,
                ListItemTextProps = _props.ListItemTextProps,
                MenuProps = _props.MenuProps,
                native = _props.native,
                selectedIndexProp = _props.selectedIndex,
                rest = _objectWithoutProperties(_props, ['id', 'classes', 'disabled', 'children', 'ContainerProps', 'ListProps', 'ListItemProps', 'ListItemTextProps', 'MenuProps', 'native', 'selectedIndex']);

            var _state = this.state,
                anchorEl = _state.anchorEl,
                selectedIndex = _state.selectedIndex;

            var id = idProp || (0, _uuid2.default)();

            var children = childrenProp;

            if (!native) {
                children = _react2.default.Children.map(childrenProp, function (child, index) {
                    return _react2.default.cloneElement(child, {
                        onClick: function onClick(event) {
                            _this2.handleMenuItemClick(event, index);
                            if (child.props.onClick) {
                                child.props.onClick(event);
                            }
                        },
                        selected: index === selectedIndex
                    });
                });
            }

            // Assume Array is sent in, else show empty label
            var selectedIndexLabel = Array.isArray(children) && children[selectedIndex].props.children || '';

            return native ? _react2.default.createElement(
                _NativeSelect2.default,
                Object.assign({
                    id: id,
                    disabled: disabled,
                    IconComponent: _ChevronDown2.default,
                    classes: {
                        root: classes.nativeSelectRoot,
                        select: classes.nativeSelect,
                        icon: (0, _classnames2.default)(classes.nativeIcon, _defineProperty({}, classes.nativeIconDisabled, disabled))
                    },
                    disableUnderline: true
                }, rest),
                children
            ) : _react2.default.createElement(
                'div',
                Object.assign({ className: classes.root }, ContainerProps),
                _react2.default.createElement(
                    _List2.default,
                    Object.assign({
                        id: id + '-container',
                        component: 'nav',
                        disablePadding: true
                    }, ListProps),
                    _react2.default.createElement(
                        _ListItem2.default,
                        Object.assign({
                            button: true,
                            disabled: disabled,
                            disableGutters: true,
                            'aria-haspopup': 'true',
                            'aria-controls': id,
                            onClick: this.handleOpenMenu,
                            classes: {
                                root: classes.listItemRoot,
                                button: classes.listItemButton,
                                disabled: classes.listItemDisabled
                            }
                        }, ListItemProps),
                        _react2.default.createElement(_ListItemText2.default, Object.assign({
                            primary: selectedIndexLabel,
                            classes: {
                                root: classes.listItemTextRoot
                            },
                            primaryTypographyProps: {
                                className: (0, _classnames2.default)(_defineProperty({}, classes.disabled, disabled))
                            }
                        }, ListItemTextProps)),
                        _react2.default.createElement(_ChevronDown2.default, {
                            className: (0, _classnames2.default)(classes.icon, _defineProperty({}, classes.disabled, disabled))
                        })
                    )
                ),
                _react2.default.createElement(
                    _Menu2.default,
                    Object.assign({
                        id: id,
                        anchorEl: anchorEl,
                        open: Boolean(anchorEl),
                        onClose: this.handleClose,
                        MenuListProps: {
                            disablePadding: true
                        },
                        classes: {
                            paper: classes.menuRoot
                        },
                        PaperProps: {
                            style: {
                                maxHeight: ITEM_HEIGHT * 7
                            }
                        }
                    }, MenuProps),
                    children
                )
            );
        }
    }]);

    return SelectionMenu;
}(_react2.default.Component);

SelectionMenu.getDerivedStateFromProps = function (props, state) {
    var index = null;
    if (props.selectedIndex < 0 || props.selectedIndex > props.children.length - 1) {
        console.warn('The value ' + props.selectedIndex + ' passed to selectedIndex is invalid. Resetting selectedIndex to 0.');
        index = DEFAULT_SELECTED_INDEX;

        return {
            anchorEl: state.anchorEl,
            selectedIndex: index
        };
    }
    return null; // Indicates no change to the state
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleOpenMenu = function (event) {
        _this3.setState({ anchorEl: event.currentTarget });
    };

    this.handleMenuItemClick = function (event, index) {
        _this3.setState({ selectedIndex: index, anchorEl: null });
    };

    this.handleClose = function () {
        _this3.setState({ anchorEl: null });
    };
};

SelectionMenu.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,
    /**
     * The unique HTML `id`. This is internally used to assist with accessibility of the nodes rendered.
     */
    id: _propTypes2.default.string,
    /**
     * The items to select from, most commonly `SelectionMenuItem`.
     *
     * If `native` is `true`, `children` should be the HTML `option` element.
     */
    children: _propTypes2.default.node,
    /**
     * If `true`, the `SelectionMenu` will be disabled.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Properties applied to the wrapping `div` component. This prop should not be used if `native` is `true`.
     */
    ContainerProps: _propTypes2.default.object,
    /**
     * Properties applied to the `Menu` component. Any other properties supplied
     * will be spread to the root element `Popover`. This prop should not be used if `native` is `true`.
     */
    MenuProps: _propTypes2.default.object,
    /**
     * Properties applied to the [`List`](#/components/List) component. This prop should not be used if `native` is `true`.
     */
    ListProps: _propTypes2.default.object,
    /**
     * Properties applied to the [`ListItem`](#/components/List) component. This prop should not be used if `native` is `true`.
     */
    ListItemProps: _propTypes2.default.object,
    /**
     * Properties applied to the [`ListItemText`](#/components/List) component. This prop should not be used if `native` is `true`.
     */
    ListItemTextProps: _propTypes2.default.object,
    /**
     * The (0-based) index of the child that will be marked as selected.
     */
    selectedIndex: _propTypes2.default.number,
    /**
     * If `true`, render a native HTML `select` element.
     */
    native: _propTypes2.default.bool,
    /**
     * Properties applied to the HTML `input` element, if `native` is `true`.
     */
    inputProps: _propTypes2.default.object,
    /**
     * Callback function fired when a menu item is selected, if `native` is `true`.
     *
     * Signature:
     * `function(event: object) => void`
     *
     * `event`: The event source of the callback. You can pull out the new value by accessing `event.target.value`.
     */
    onChange: _propTypes2.default.func,
    /**
     * The value of the HTML `input` element, if `native` is `true`.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool])
};

SelectionMenu.defaultProps = {
    selectedIndex: DEFAULT_SELECTED_INDEX
};

exports.default = (0, _styles2.default)(styles)(SelectionMenu);